import { STATUSES } from '../shared/constants/general-constants';
import { Asset } from './asset';

export class Insight extends Asset {
  public id?: number;
  public category: string;
  public name: string;
  public status?: string = STATUSES.INACTIVE;
  public batch_job_id?: string;

  // Make insights easier to find
  public tags?: string[]; // FIXME should be a Set<string>
  public description?: string;

  // If this is an Acela-based trigger, this is the query that will be executed
  public query?: string;

  // Metadata
  public created_dttm?: number;
  public created_by?: string;
  public last_updated_dttm?: number;
  public last_updated_by?: string;

  // Lifecycle values
  public enabled?: boolean;
  public schedule?: string; // How often the insight is run
  public schedule_seconds?: number; // How oftehn the insight is run in seconds
  public rule?: string; // Cloudwatch Event rule
  public next_run_time?: number;
  public last_run_time?: number;

  // Simple metrics
  public executions: number = 0;
  public total_duration: number = 0;
  public total_results: number = 0;

  //Dates
  public start_date?: number;
  public end_date?: number;

  constructor() {
    super();
  }

  public get label() {
    return ('' + this.id).padStart(3, '0') + ' - ' + this.name;
  }

  public static copy(sourceInsight: Insight) {
    const targetInsight = new Insight();
    Object.assign(targetInsight, sourceInsight);

    return targetInsight;
  }

  public static clone(insight: Insight) {
    const clonedInsight: Insight = new Insight();
    Object.assign(clonedInsight, insight);
    clonedInsight.name = 'Clone - ' + insight.name;

    //resetting the metrics
    clonedInsight.executions = 0;
    clonedInsight.total_results = 0;
    clonedInsight.total_duration = 0;

    clonedInsight.enabled = false;
    clonedInsight.last_run_time = null;
    clonedInsight.next_run_time = null;
    clonedInsight.status = STATUSES.INACTIVE;

    delete clonedInsight.id;

    return clonedInsight;
  }
}
